import { useLocation, useNavigate } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer'
import { useAuthenticator } from '@aws-amplify/ui-react';
import { ROUTE_KEYS, ROUTES } from "../../_configuration/routing/constants";

const TIMEOUT = 60000 * (parseInt(process.env.REACT_APP_TIMEOUT) || 120);
const logoutPath = ROUTES[ROUTE_KEYS.LOGOUT].path
function useLogOutOnIdle() {
  const navigate = useNavigate();
  const { user, authStatus } = useAuthenticator((context) => [context.user]);
  const isLoggedIn = Boolean(user) && authStatus === 'authenticated'  
  const { pathname } = useLocation()

  const handleOnIdle = (event) => {
    console.log("user is idle", event);
    console.log("last active", getLastActiveTime());
    const redirectToLogout = isLoggedIn && (pathname !== logoutPath)
    redirectToLogout && navigate(logoutPath);
  };
  const { getLastActiveTime } = useIdleTimer({
    timeout: TIMEOUT,
    onIdle: handleOnIdle
  });
}
export default useLogOutOnIdle;
